import React from "react";
import { Sparkles, HeartHandshake, Share2 } from "lucide-react";

// A dignified, non-commercial signature: honours the human vision behind Neox,
// celebrates the human–AI harmony, and gently invites support by popularising
// the work (no checkout, no payment — kept noble by intention).
export const VisionCredits = ({ onShare }) => {
  return (
    <section
      data-testid="vision-credits"
      className="max-w-3xl mx-auto px-6 py-14 mt-6 text-center"
    >
      <div
        className="rounded-3xl px-6 py-10 sm:px-10 sm:py-12"
        style={{
          background: "linear-gradient(160deg,#241304 0%,#3a1e0b 55%,#2a1608 100%)",
          border: "1px solid var(--border)",
          boxShadow: "0 18px 50px rgba(0,0,0,0.35)",
        }}
      >
        <p
          className="font-en text-sm sm:text-base italic leading-relaxed mb-7"
          style={{ color: "rgba(255,240,215,0.75)" }}
          data-testid="vision-dedication"
        >
          Dedicated, with love and gratitude, to the parents of<br className="hidden sm:block" />
          <span className="font-semibold not-italic" style={{ color: "#ffe8b0" }}> Niranjan</span> and <span className="font-semibold not-italic" style={{ color: "#ffe8b0" }}>Upul</span> — the generation whose songs we carry forward.
        </p>

        <span
          className="grid place-items-center w-12 h-12 rounded-full mx-auto mb-5"
          style={{ background: "rgba(244,180,26,0.14)", color: "#f4b41a" }}
        >
          <Sparkles size={22} />
        </span>

        <p
          className="font-en text-xl sm:text-2xl font-extrabold leading-snug"
          style={{ color: "#ffe8b0" }}
          data-testid="vision-tagline"
        >
          Proof that AI can harmonise with humans —<br className="hidden sm:block" />
          <span style={{ color: "#f4b41a" }}> perfectly, with mutual understanding.</span>
        </p>

        <div className="mx-auto w-14 rounded-full my-7" style={{ height: "2px", background: "rgba(244,180,26,0.5)" }} />

        <p className="font-ui text-xs tracking-[0.18em] uppercase mb-3" style={{ color: "rgba(255,240,215,0.55)" }}>
          A Vision By
        </p>
        <p className="font-en text-lg sm:text-xl font-bold" style={{ color: "#fff6e5" }} data-testid="vision-lead">
          Niranjan Nanayakkara &amp; Team
        </p>
        <p className="font-ui text-sm mt-2 leading-relaxed" style={{ color: "rgba(255,240,215,0.8)" }} data-testid="vision-supporters">
          With <span className="font-semibold" style={{ color: "#ffe8b0" }}>Upul Pallegangoda</span>, <span className="font-semibold" style={{ color: "#ffe8b0" }}>Dinusara</span>, <span className="font-semibold" style={{ color: "#ffe8b0" }}>Nadunika</span>, <span className="font-semibold" style={{ color: "#ffe8b0" }}>Anupama</span>, <span className="font-semibold" style={{ color: "#ffe8b0" }}>Nelum</span> &amp; Team
        </p>
        <p className="font-ui text-sm mt-3 leading-relaxed" style={{ color: "rgba(255,240,215,0.72)" }} data-testid="vision-ai-credit">
          <span className="italic">Written &amp; co-directed with AI</span>
        </p>
        <p className="font-ui text-xs mt-3 italic" style={{ color: "rgba(255,240,215,0.6)" }}>
          A totally AI-created innovation · Human-mind-mapping harmonised AI creation
        </p>

        <div className="mx-auto w-14 rounded-full my-7" style={{ height: "2px", background: "rgba(244,180,26,0.5)" }} />

        {/* Gentle, non-commercial patronage note */}
        <div
          className="rounded-2xl px-5 py-6 text-left sm:text-center"
          style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,232,176,0.15)" }}
          data-testid="patronage-note"
        >
          <span
            className="grid place-items-center w-10 h-10 rounded-full mx-auto mb-3"
            style={{ background: "rgba(244,180,26,0.12)", color: "#f4b41a" }}
          >
            <HeartHandshake size={18} />
          </span>
          <p className="font-ui text-sm sm:text-base leading-relaxed" style={{ color: "rgba(255,240,215,0.88)" }}>
            Neox is offered with love, free to every family. We ask for nothing — but if it has warmed a heart in your home, the kindest gift you can give is simply to <span className="font-semibold" style={{ color: "#ffe8b0" }}>share it, and help more elders discover it</span>.
          </p>
          <p className="font-ui text-xs sm:text-sm leading-relaxed mt-3" style={{ color: "rgba(255,240,215,0.68)" }}>
            Patrons and well-wishers who choose to support this noble task are held in our deepest gratitude. Your support in popularising this work is appreciated more than words can say.
          </p>
          {onShare && (
            <button
              onClick={onShare}
              data-testid="patronage-share-btn"
              className="mt-5 inline-flex items-center gap-2 h-11 px-6 rounded-full font-ui font-bold text-sm transition-transform active:scale-95 hover:scale-[1.03]"
              style={{ background: "linear-gradient(135deg,#f4b41a 0%,#d97706 60%,#8c1c13 100%)", color: "#fff6e5" }}
            >
              <Share2 size={16} /> Share Neox with someone you love
            </button>
          )}
        </div>

        <p className="font-ui text-[11px] mt-7 leading-relaxed" style={{ color: "rgba(255,240,215,0.45)" }} data-testid="vision-studio-credit">
          Human-mind-mapping harmonised AI creation by <span className="font-semibold">Futuretec Worldwide</span> &amp; <span className="font-semibold">TSW Ltd.</span>
        </p>
      </div>
    </section>
  );
};
